var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('span',[_vm._t("default",null,{"resource_url":_vm.resource_url,"data":_vm.data,"loaded":_vm.loaded})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }